import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../Store';

export const commonProvince = (state: AppState) => state.common;

export const commonSelector = createSelector(commonProvince, (state) => state);
